import React from "react";
import { Callout, CalloutVariant } from "./Callout";
import { TextField } from "@mui/material";
import validator from "validator";
import { OrganizationDto } from "../../common/service/server/dto/OrganizationDto";

interface EmailCalloutPropsBase {
  emailSubject: string;
  emailBody: string;
  setEmailBody: (body: string) => void;
  emailLoading: boolean;
  emailSent: boolean;
  org: OrganizationDto;
}

interface EmailCalloutPropsForMultipleVendors extends EmailCalloutPropsBase {
  vendorIdToEmailMap: Map<string, string>;
  setEmailRecipientsDialogOpen: (open: boolean) => void;
  vendorEmail?: never;
  setVendorEmail?: never;
}

interface EmailCalloutPropsForSingleVendor extends EmailCalloutPropsBase {
  vendorEmail: string;
  setVendorEmail: (email: string) => void;
  vendorIdToEmailMap?: never;
  setEmailRecipientsDialogOpen?: never;
}

type EmailCalloutProps = EmailCalloutPropsForMultipleVendors | EmailCalloutPropsForSingleVendor;

export const EmailCallout = (props: EmailCalloutProps) => {
  const { emailSubject, emailBody, setEmailBody, emailLoading, emailSent, org } = props;

  const signature = org?.messageSettings?.messageSignature
    ? org.messageSettings.messageSignature
    : `Thank you,\n${org?.name || ""}`;

  return (
    <Callout className="p-mdlg mb-md" variant={CalloutVariant.LightGray}>
      {/* Handle multiple vendors */}
      {"vendorIdToEmailMap" in props && (
        <p>
          To:{" "}
          {Array.from(props.vendorIdToEmailMap.values()).filter(
            (email) => Boolean(email) && validator.isEmail(email),
          ).length > 0 ? (
            <span
              className="text-weight-medium cursor-pointer text-decoration-underline color-secondary-600"
              onClick={() => {
                props.setEmailRecipientsDialogOpen(true);
              }}
            >
              see recipients
            </span>
          ) : (
            <span className="text-weight-medium">No valid recipients</span>
          )}
        </p>
      )}

      {/* Handle single vendor */}
      {"vendorEmail" in props && <p className="text-weight-bold">{props.vendorEmail}</p>}

      <p className="text-weight-bold">Subject: {emailSubject}</p>
      <TextField
        className="background-color-white"
        multiline={true}
        fullWidth={true}
        onChange={(e) => {
          setEmailBody(e.target.value);
        }}
        value={emailBody}
        disabled={emailLoading || emailSent}
      />
      <p style={{ whiteSpace: "pre-wrap" }}>{signature}</p>
    </Callout>
  );
};
